import { PaymentReminderInterval } from "@SiteManagement/PaymentReminders/types/paymentreminders";

const TEMPLATE_KEY_PATTERN = /^[a-z0-9]+_(.+)_payment_reminder$/;

/** Returns the interval segment of a template key, or the key itself when it does not match. */
const getReminderInterval = (templateKey: string): PaymentReminderInterval => {
    const match = TEMPLATE_KEY_PATTERN.exec(templateKey);
    return (match ? match[1] : templateKey) as PaymentReminderInterval;
};

export default getReminderInterval;
